import React from 'react'
import Navbar from '../inc/Navbar'
import Slider from '../inc/Slider'
import flatelevation from "../images/elevation flat berhampore.jpeg"
import flatlayout from "../images/flat layout dragon.jpg";
import Elevation from "../images/elevation flat berhampore new.pdf";
import Download from "../images/layout.pdf";
import "./Home.css";
import Amenities from './Amenities';

import ScrollToTop from "react-scroll-to-top";
function Home() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />
            <ScrollToTop smooth top="100" color="Darkblue" />
            <Slider />
            <div className='marqueeback'>
                <marquee><h4 className='mt-2' style={{ color: "maroon" }} >Welcome To Dragon Construction | 43, Shri Krishna saha lane,
                    PO+PS Berhampore</h4></marquee>
            </div>
            <div className="album py-1">
                <div className="container">
                    <div className='btn-grad32 mb-2'><b>PROJECT LOCATION  <br/>

                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-geo-alt" viewBox="0 0 16 16">
                    <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10" />
                    <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                  </svg> Natun Para, Near Bandhab Press, Khagra, Pin - 742103, Dist.- Murshidabad, WB
                    </b></div>
                </div>
            </div>

            <div className="album py-1">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4 mt-3">
                            <div className="card" >
                                <div className='btn-grad42 mb-2'><b>2 BHK FLAT AVAILABLE</b></div>
                                <div className="card-body">
                                    <h5 className="card-title">2 BHK FLAT </h5>
                                    <h6 style={{ color: "darkBlue" }} className="card-text mb-2"><b>Apartment The Loft Life</b> </h6>
                                    <p><small>All main Door video calling camera</small></p>

                                    <a href="tel: 8145068505" className="flatbutton">Flat Book Now</a>
                                </div>
                            </div>

                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="card" >
                                <div className='btn-grad42 mb-2'><b>3 BHK FLAT AVAILABLE</b></div>
                                <div className="card-body">
                                    <h5 className="card-title">3 BHK FLAT </h5>
                                    <h6 style={{ color: "darkBlue" }} className="card-text mb-2"><b>Apartment The Loft Life</b> </h6>
                                    <p><small>All main Door video calling camera</small></p>

                                    <a href="tel: 8145068505" className="flatbutton">Flat Book Now</a>
                                </div>
                            </div>

                        </div>


                    </div>
                </div>
            </div>
            <br />
            <div className="album py-1">
                <div className="container">
                    <h2 style={{ color: "darkBlue" }}>Apartment The Loft Life</h2>
                </div>
            </div>

            <Amenities />
            <br />



            <div className="album py-1">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4 mt-3">
                            <div className="card" >
                                <img src={flatlayout} className="card-img-top" alt="flatlayout" />
                                <div className="card-body">
                                    <h5 className="card-title">Flat Layout </h5>

                                    <a href={Download} className="flatbutton">Download <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cloud-arrow-down" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708z" />
                                        <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383m.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                                    </svg></a>
                                </div>
                            </div>

                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="card" >
                                <img src={flatelevation} className="card-img-top" alt="flatelevation" />

                                <div className="card-body">
                                    <h5 className="card-title">Flat Elevation</h5>
                                    <a href={Elevation} className="flatbutton">Download <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cloud-arrow-down" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708z" />
                                        <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383m.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                                    </svg></a>
                                </div>
                            </div>

                        </div>


                    </div>
                </div>
            </div>
            <br />
        </div>
    )
}

export default Home